import tw, { css, TwStyle } from 'twin.macro'

const ParagraphStyle = (overWrite?: TwStyle) =>
  css(
    tw`tracking-wider lg:text-lg md:text-base text-sm leading-normal`,
    overWrite && overWrite,
  )

export default ParagraphStyle
